import apiService from 'config/service';

export const sendUpsellRequestToBlip = (key: string) => {
  apiService.post(`company/upsell/${key}`);
};
